import { motion } from "framer-motion";

// Optimized image URLs with smaller sizes (w=400 for thumbnails)
const coupleData = {
  groom: {
    name: "Kevin Wijaya",
    role: "The Groom",
    title: "First Son of",
    parents: {
      father: "Mr. William Wijaya",
      mother: "Mrs. Linda Hartono",
    },
    bio: "A passionate entrepreneur with a love for traditional values and modern vision.",
    image:
      "https://img.freepik.com/free-photo/smiling-asian-man-holding-bunch-roses_1262-18322.jpg?t=st=1773157546~exp=1773161146~hmac=7e0ce0e469634e38392693c43fdbfb083be5de58db24a09e73b02d5fe1e47844",
    // "https://images.unsplash.com/photo-1612013911628-5fc53c51341d?w=400&q=75&auto=format&fit=crop",
  },
  bride: {
    name: "Michelle Tanaka",
    role: "The Bride",
    title: "Second Daughter of",
    parents: {
      father: "Mr. David Tanaka",
      mother: "Mrs. Christina Liem",
    },
    bio: "A creative soul who believes in the beauty of cultural traditions and timeless love.",
    image:
      "https://images.unsplash.com/photo-1615262239785-16bed1b9a051?q=80&w=1074&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    // image: 'https://images.unsplash.com/photo-1596744744451-5bf15b283026?w=400&q=75&auto=format&fit=crop',
  },
};

const CoupleCard = ({ data, direction }) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: direction === "left" ? -50 : 50 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className="couple-card flex flex-col items-center text-center"
    >
      {/* Image with decorative frame */}
      <div className="relative mb-6 sm:mb-8">
        <div className="absolute -inset-3 sm:-inset-4 border border-[#D4AF37] opacity-40" />
        <div className="absolute -inset-1.5 sm:-inset-2 border border-[#D4AF37] opacity-60" />
        <img
          src={data.image}
          alt={data.name}
          className="couple-image rounded-sm"
          loading="lazy"
          data-testid={`couple-image-${data.role
            .toLowerCase()
            .replace(" ", "-")}`}
        />
      </div>

      {/* Role Label */}
      <p className="font-serif-accent text-[10px] sm:text-xs tracking-[0.2em] sm:tracking-[0.3em] text-[#D4AF37] uppercase mb-2 sm:mb-3">
        {data.role}
      </p>

      {/* Name */}
      <h3
        className="font-serif-heading text-2xl sm:text-3xl md:text-4xl text-[#8B0000] mb-3 sm:mb-4"
        data-testid={`couple-name-${data.role.toLowerCase().replace(" ", "-")}`}
      >
        {data.name}
      </h3>

      {/* Decorative Divider */}
      <div className="w-10 sm:w-12 h-px bg-[#D4AF37] mb-3 sm:mb-4" />

      {/* Parents */}
      <p className="font-sans text-xs sm:text-sm text-[#5A5A5A] mb-1 sm:mb-2">
        {data.title}
      </p>
      <p className="font-sans text-sm sm:text-base text-[#2D2D2D] mb-1">
        {data.parents.father}
      </p>
      <p className="font-sans text-xs sm:text-sm text-[#5A5A5A] mb-1">&</p>
      <p className="font-sans text-sm sm:text-base text-[#2D2D2D] mb-3 sm:mb-4">
        {data.parents.mother}
      </p>

      {/* Bio */}
      {/* <p className="font-sans text-xs sm:text-sm text-[#5A5A5A] italic max-w-xs leading-relaxed px-2">
        "{data.bio}"
      </p> */}
    </motion.div>
  );
};

const CoupleSection = () => {
  return (
    <section
      className="section-wrapper py-16 sm:py-20 md:py-32 px-4 sm:px-6"
      data-testid="couple-section"
    >
      <div className="max-w-5xl mx-auto">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-10 sm:mb-16"
        >
          <p className="font-serif-accent text-[10px] sm:text-xs tracking-[0.2em] sm:tracking-[0.3em] text-[#D4AF37] uppercase mb-3 sm:mb-4">
            The Couple
          </p>
          <h2 className="font-serif-heading text-2xl sm:text-3xl md:text-5xl text-[#8B0000]">
            {/* Two Hearts, One Journey */}
            Honouring our Bride & Groom
          </h2>
        </motion.div>

        {/* Couple Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 sm:gap-12 md:gap-16">
          <CoupleCard data={coupleData.bride} direction="left" />
          <CoupleCard data={coupleData.groom} direction="right" />
        </div>

        {/* Center Symbol */}
        <motion.div
          initial={{ opacity: 0, scale: 0.5 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex justify-center mt-6 sm:mt-8"
        >
          {/* <span className="double-happiness text-4xl sm:text-5xl text-[#D4AF37] opacity-50">
            囍
          </span> */}
        </motion.div>
      </div>
    </section>
  );
};

export default CoupleSection;
